import { render } from "./OrderDetailDialog.vue?vue&type=template&id=1b6aff3e&scoped=true"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js"

import "./OrderDetailDialog.vue?vue&type=style&index=0&id=1b6aff3e&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6aff3e"]])

export default __exports__